module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular.woff2
// module id = 268
// module chunks = 0